<template>
  <div class="pay-method">
    <Resource class="goods-image" :src="goodImage"></Resource>
    <PayPrice :text="priceText" class="mt-[20px]" />
    <a-button
      :disabled="!agreementChecked || loading"
      class="hpp-button mt-[12px]"
      type="primary"
      @click="handlePayClick"
    >
      {{ $t('qu-zhi-fu') }}
    </a-button>
    <PayAgreement
      :checked="agreementChecked"
      :buyType="buyType"
      class="mt-[45px] w-[280px]"
      @checked="onChecked"
    />
  </div>
</template>

<script setup lang="ts">
import { type Payment } from '@airwallex/components-sdk'
import PayPrice from './pay-price.vue'
import PayAgreement from './pay-agreement.vue'

import { hpp } from '~/features/payment/airwallex'
import type { IOrder } from '~/api/interface/order'
import type { BUY_TYPE } from '~/api/interface'

const goodImage = getFeUrl('/youyan-platform/png/home/package.png')

const props = defineProps<{
  agreementChecked: boolean
  loading: boolean
  priceText: number
  buyType: BUY_TYPE
  order?: IOrder

  paymentConfig?: (
    config: Partial<Payment.HostPaymentPage>
  ) => Payment.HostPaymentPage
}>()

const handlePayClick = () => {
  if (!props.order) {
    return
  }

  const cfg = {
    customer_id: props.order?.other_info.vendor_customer_id,
    currency: props.order?.currency,
    client_secret: props.order?.other_info.airwallex_client_secret,
    intent_id: props.order?.vendor_trade_no,
  }

  hpp('recurring', props.paymentConfig ? props.paymentConfig(cfg) : cfg)
}

const emits = defineEmits(['update:agreementChecked'])

function onChecked(checked: boolean) {
  emits('update:agreementChecked', checked)
}
</script>

<style lang="scss" scoped>
.hpp-button {
  width: 280px;
  height: 44px;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
}
.goods-image {
  width: 100%;
  width: 280px;
  height: 197px;
}
</style>
